import React, { useEffect, useState } from "react";
import s from "./UpdateSpare.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSpareImages,
  getSpareDetails,
  updateSpare,
} from "../../redux/carSlice";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { condition, currency, rangeFuelVolume, rangeYear } from "../../data";
import MySidebar from "../../components/MySidebar/MySidebar";
import ReactQuill from "react-quill";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
const { TextArea } = Input;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UpdateSpare = () => {
  const dispatch = useDispatch();
  const spare = useSelector((state) => state.cars.spareDetails);
  const params = useParams();
  const [form] = Form.useForm();
  const [newImages, setNewImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const [fileList, setFileList] = useState(
    spare?.images?.map((it) => ({
      uid: it?.id.toString(),
      url: it?.image,
      status: "done",
      name: it?.image?.split("/").pop(),
    }))
  );

  useEffect(() => {
    setFileList(
      spare?.images?.map((it) => ({
        uid: it?.id.toString(),
        url: it?.image,
        status: "done",
        name: it?.image?.split("/").pop(),
      }))
    );

    form.setFieldsValue({
      category: {
        value: spare?.vehicle_type?.id,
        label: spare?.vehicle_type?.name,
      },
      vechicle_subtype: {
        value: spare?.sub_vehicle_type?.id,
        label: spare?.sub_vehicle_type?.name,
      },
      brand: { value: spare?.brand?.id, label: spare?.brand?.name },
      model: { value: spare?.model?.id, label: spare?.model?.name },
      manufacture_date: spare?.manufacture_date,
      manufacturer: spare?.manufacturer,
      name: spare?.name,
      number: spare?.number,
      condition: {
        value: spare?.condition,
        label: condition.find((it) => it === spare?.condition)?.name,
      },
      availability: {
        value: spare?.availability,
        label: spare.availability === "available" ? "В наличии" : "На заказ",
      },
      seller_comment: spare?.seller_comment,
      price: spare?.price,
      currency: {
        value: spare?.currency,
        label: currency.find((it) => it === spare?.currency)?.name,
      },
      phone: spare?.phone,
    });
  }, [spare, form]);

  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState();
  const brands = useSelector((state) => state.cars.brandList);
  const models = useSelector((state) => state.cars.modelList);
  const carTypes = useSelector((state) => state.cars.categories);
  const [activeSubcategories, setActiveSubcategories] = useState(
    carTypes.find((it) => it.id === spare?.vehicle_type?.id)?.sub_types
  );
  const [activeSubCategory, setActiveSubcategory] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [changedFields, setChangedFields] = useState({});
  const [description, setDescription] = useState("");

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы обновили объявление о продажe запчасти!",
    });
  };

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const selectSubcategories = (value) => {
    const data = carTypes.find((it) => it.id === value)?.sub_types;
    setActiveSubcategories(data);
  };

  const currentYear = new Date().getFullYear();
  const years = rangeYear(currentYear, currentYear - 50, -1);
  const fuelVolume = rangeFuelVolume(0.5, 6, 0.1);

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleValuesChange = (changedValues) => {
    setChangedFields((prevChangedFields) => ({
      ...prevChangedFields,
      ...changedValues,
    }));
  };

  const handleRemoveImages = (value) => {
    setDeletedImages((prevImages) => [...prevImages, Number(value.uid)]);
    setFileList(fileList.filter((it) => it.uid !== value.uid));
  };

  const sendForm = async () => {
    const data = new FormData();

    Object.entries(changedFields).forEach(([key, value]) => {
      console.log("key, value", key, value);
      data.append(key, value.value || value);
    });

    newImages.length > 0 &&
      newImages.forEach((image) => {
        data.append("images", image.originFileObj);
      });

    if (deletedImages.length > 0) {
      dispatch(deleteSpareImages({ image_ids: deletedImages }));
    }

    const res = await dispatch(updateSpare({ id: Number(params.id), data }));

    if (res.type === "spares/updateSpare/fulfilled") {
      success();
      dispatch(getSpareDetails(params?.id));
      setNewImages([]);
      navigate("/mySpares");
    }
  };

  return (
    <div className={s.addCar}>
      {contextHolder}
      {width > 1000 ? <div className={s.top}>top</div> : null}

      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}
          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar />
              </div>
              <div className={s.announcements}>
                <div>
                  <div className={s.contentWrapper1}>
                    <Link to='/mySpares' className={s.back}>
                      <ArrowLeftOutlined /> &nbsp;Назад
                    </Link>
                    <div className={s.header}>
                      <div className={s.top_photo_wrapper}>
                        <img
                          src={
                            spare &&
                            spare.images.length > 0 &&
                            spare?.images[0]?.image
                          }
                          className={s.top_photo}
                        />
                      </div>
                      <h2 className={s.h2}>
                        <EditOutlined /> &nbsp;Обновить запчасть
                      </h2>
                    </div>
                    <div className={s.content1}>
                      <Form
                        form={form}
                        className={s.form}
                        encType='multipart/form-data'
                        layout='vertical'
                        onFinish={sendForm}
                        onValuesChange={handleValuesChange}
                      >
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Категория'
                              name='category'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите  категорию",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Категории'
                                options={carTypes
                                  ?.filter(
                                    (el) =>
                                      el.id !== 4 && el.id !== 6 && el.id !== 7
                                  )
                                  ?.map((it) => ({
                                    value: it?.id,
                                    label: it?.name,
                                  }))}
                                onSelect={(value) => {
                                  selectSubcategories(value);
                                  setActiveSubcategory(undefined);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='vechicle_subtype'
                              label='Тип транспортного средства'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите тип транспортного средства",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Тип транспортного средства'
                                options={activeSubcategories?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                // value={activeSubCategory}
                                onSelect={(value) =>
                                  setActiveSubcategory(value)
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Марка'
                              name='brand'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите Марку",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Марка'
                                options={brands?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                onSelect={(value) => {
                                  selectModels(value);
                                  setModelValue(undefined);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Модель'
                              name='model'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите Модель",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Модель'
                                options={modelsByBrand?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                onSelect={(value) => setModelValue(value)}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='name'
                              label='Название'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите наименование детали",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите наименование детали'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='number'
                              label='Модель/номер детали'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите кузов",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите модель/номер детали'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='manufacture_date'
                              label='Год выпуска'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите год выпуска",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите год выпуска'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Наличие'
                              name='availability'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите наличие запчасти",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Наличие'
                                options={[
                                  {
                                    value: "available",
                                    label: "В наличии",
                                  },
                                  {
                                    value: "order",
                                    label: "На заказ",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Цена, USD'
                              name='price'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите цену",
                                },
                              ]}
                            >
                              <input placeholder='Цена' className={s.input} />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Производитель'
                              name='manufacturer'
                              rules={[
                                {
                                  required: true,
                                  message: "yкажите производителя",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Производитель'
                                options={[
                                  {
                                    value: "china",
                                    label: "Китай",
                                  },
                                  {
                                    value: "japan",
                                    label: "Япония",
                                  },
                                  {
                                    value: "germany",
                                    label: "Германия",
                                  },
                                  {
                                    value: "south_korea",
                                    label: "Южная Корея",
                                  },
                                  {
                                    value: "russia",
                                    label: "Россия",
                                  },
                                  {
                                    value: "usa",
                                    label: "США",
                                  },
                                  {
                                    value: "taiwan",
                                    label: "Тайвань",
                                  },
                                  {
                                    value: "india",
                                    label: "Индия",
                                  },
                                  {
                                    value: "uk",
                                    label: "Великобритания",
                                  },
                                  {
                                    value: "italy",
                                    label: "Италия",
                                  },
                                  {
                                    value: "france",
                                    label: "Франция",
                                  },
                                  {
                                    value: "brazil",
                                    label: "Бразилия",
                                  },
                                  {
                                    value: "kazakhstan",
                                    label: "Казахстан",
                                  },
                                  {
                                    value: "orther",
                                    label: "Другое",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Состояние'
                              name='condition'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите состояние",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Привод'
                                options={[
                                  {
                                    value: "new",
                                    label: "Новое",
                                  },
                                  {
                                    value: "used",
                                    label: "БУ",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Описание'
                              name='seller_comment'
                              rules={[
                                {
                                  required: true,
                                  message: "Опишите ваше авто",
                                },
                              ]}
                            >
                              <ReactQuill
                                value={description}
                                onChange={setDescription}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          {/* <Col span={4}>
                            <Form.Item
                              label='Валюта'
                              name='currency'
                              initialValue={{ value: "usd", label: "USD" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите валютy",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Выберите валютy'
                                options={[
                                  { value: "usd", label: "USD" },
                                  { value: "cny", label: "CNY" },
                                  { value: "kgs", label: "KGS" },
                                  { value: "rub", label: "RUB" },
                                ]}
                              />
                            </Form.Item>
                          </Col> */}
                          {/* <Col span={12}>
                            <Form.Item
                              label='Телефон'
                              name='phone'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите номер телефона",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите номер телефона'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col> */}
                        </Row>
                        <Row gutter={24}>
                          <Col span={24}>
                            <Form.Item name='images'>
                              <Upload
                                listType='picture-card'
                                accept='image/*'
                                fileList={fileList}
                                onPreview={() => handlePreview}
                                onRemove={(value) => handleRemoveImages(value)}
                                multiple={true}
                                beforeUpload={() => false}
                              ></Upload>
                              {previewImage && (
                                <Image
                                  wrapperStyle={{
                                    display: "none",
                                  }}
                                  preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) =>
                                      setPreviewOpen(visible),
                                    afterOpenChange: (visible) =>
                                      !visible && setPreviewImage(""),
                                  }}
                                  src={previewImage}
                                />
                              )}
                            </Form.Item>
                            <Form.Item name='newImages' label='Загрузите фото'>
                              <Upload
                                listType='picture-card'
                                accept='image/*'
                                fileList={newImages}
                                onPreview={() => handlePreview}
                                onChange={(e) => setNewImages(e.fileList)}
                                multiple={false}
                                beforeUpload={() => false}
                              >
                                {uploadButton}
                              </Upload>
                              {previewImage && (
                                <Image
                                  wrapperStyle={{
                                    display: "none",
                                  }}
                                  preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) =>
                                      setPreviewOpen(visible),
                                    afterOpenChange: (visible) =>
                                      !visible && setPreviewImage(""),
                                  }}
                                  src={previewImage}
                                />
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row span={24} className={s.btn_row}>
                          <Button className={s.btn} htmlType='submit'>
                            <EditOutlined />
                            &nbsp;Отредактировать запчасть
                          </Button>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>
      <Footer />
    </div>
  );
};

export default UpdateSpare;
